import HBIcon from "@/components/HBIcon";
import { PIN_OPEN_TYPE } from "@/constants/pinOpenType";
import useAppStore from "@/context/store";
import getNextDetailsSetp from "@/utils/getHistorySetp";
import { useRouter } from "next/router";
import { memo, useMemo } from "react";
import { When } from "react-if";
import styles from "../index.module.less";
import PinTopicPinList from "./PinTopicPinList";

/*** 采集所在主题 */
function PinTopic({ data, isModal }) {
  const router = useRouter();
  const { currentPin, pinOpenType } = useAppStore(
    ({ currentPin, pinOpenType }) => ({
      currentPin,
      pinOpenType,
    })
  );

  const onSelectPin = (pin: IPin, currentSrc: string, source: string) => {
    const param = source ? `?from=${source}` : "";
    const pinId = pin.pin_id;
    if (pinOpenType === PIN_OPEN_TYPE.BLANK) {
      window.open(`/pins/${pinId}${param}`);
      return;
    }
    if (isModal) {
      // currentSrc用于渐进式显示图片，先显示缓存图，再显示大图
      useAppStore.setState({ currentPin: { pinId, currentSrc } });
      let detailsSetp = getNextDetailsSetp();
      let historyData =
        typeof history?.state === "object" ? history?.state : {};
      window.history.pushState(
        { ...historyData, detailsSetp },
        null,
        `/pins/${pinId}${param}`
      );
    } else {
      // 用于渐进式显示图片，先显示缓存图，再显示大图，但是这个router.push的方式所以只能把缓存图片地址通过window传递
      window._pinDetailCurrentSrc = currentSrc;
      router.push(`/pins/${pinId}${param}`);
    }
  };
  const pin = useMemo(() => {
    return data || currentPin;
  }, [data, currentPin]);

  const title = useMemo(() => {
    const title =
      pin?.related_topic?.content_title || pin?.related_topic?.title;
    return title ? `相关主题-${title}` : "";
  }, [pin]);

  return (
    <>
      <div className={styles.board}>
        <div className={styles.desc}>
          <div className={styles.left}>
            <When condition={title}>
              <a
                className={styles.name}
                data-gd-click="button_click"
                data-button-name="打开采集所在主题"
                href={`/topics/topic-${data.related_topic.urlname}-${data.related_topic.filter_id}`}
                target="_blank"
              >
                <HBIcon className={styles.icon} type="ic_tag" />
                <span className={styles.text} title={title}>
                  {title}
                </span>
              </a>
            </When>
          </div>
          <div className={styles.right}>
            <a
              className={styles.name}
              data-gd-click="button_click"
              data-button-name="打开采集所在主题"
              href={`/topics/topic-${data.related_topic.urlname}-${data.related_topic.filter_id}`}
              target="_blank"
            >
              <div className={styles.num}>
                {pin?.related_topic?.pin_count === 10000
                  ? "1w+" // 后端返回的数量最多10000，所以当10000时，显示1w+
                  : pin?.related_topic?.pin_count || 0}
                采集
                <HBIcon className={styles.icon} type="ic_chevron_right" />
              </div>
            </a>
          </div>
        </div>
        <PinTopicPinList
          related_topic={data.related_topic}
          onSelect={onSelectPin}
          pinId={data.pin_id}
        />
      </div>
    </>
  );
}
export default memo(PinTopic);
